import { gql, useQuery } from '@apollo/client';
import { brandTitleByKey } from '@prismamedia/one-brandkey';
import { client } from '..';
import { GetBrandKeysQuery } from '../../__generated__/queries-newsletter';

const GET_BRANDKEYS_QUERY = gql`
  query GetBrandKeys {
    getBrandKeys
  }
`;

export const useGetBrandKeys = () =>
  useQuery<GetBrandKeysQuery>(GET_BRANDKEYS_QUERY);

const removeAccents = (str: string) =>
  str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const getBranKeys = async (search: string) => {
  const res = await client.query<GetBrandKeysQuery>({
    query: GET_BRANDKEYS_QUERY,
  });
  const regex = new RegExp(removeAccents(search), 'i');
  return res.data.getBrandKeys
    .map((key) => ({ id: key, label: brandTitleByKey[key] }))
    .filter(({ label }) => removeAccents(label).match(regex));
};
